import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

//import Images
import bgimg from "../../assets/images/me-2.jpg";

export default class index extends Component {
  render() {
    return (
      <React.Fragment>
        <section className="bg-half bg-light d-table w-100">
          <Container>
            <Row className="align-items-center">
              <Col md={6} xs={12}>
                <div className="title-heading">
                  <span className="badge badge-pill badge-soft-primary">
                    Development Web
                  </span>
                  <h1 className="mt-2 mb-3">
                    Salut, <br /> Je suis <span className="font-weight-bold">Arthur Monteiro</span>
                  </h1>
                  <p className="para-desc text-muted">
                    Developpeur Front-End & designer
                  </p>
                  <div className="mt-4 pt-2">
                    <Link to="/contact" className="btn btn-primary mr-2">
                      Contacter
                    </Link>
                  </div>
                  <p className="text-muted mb-0 mt-3">Jette un oeil à mon site !</p>
                </div>
              </Col>

              <div className="col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0 ">
                <img src={bgimg} className="img-fluid d-block mx-auto rounded-md " alt="" />
              </div>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
